<template>
    <div v-if="sub && sub.events && !sub.isOver">
        <form ref="form_subscription" :action="hiddenForm.action" method="post">
            <input type="hidden" name="ticket" :value="hiddenForm.id">
            <input type="hidden" name="login_token" :value="hiddenForm.token">
            <input type="hidden" name="checkout_type" value="standard">
        </form>
        <section class="content_block" v-for="ev in sub.events" :key="ev.id">
            <div class="card-Event ">
                <h3 class="card-Event__Title">{{ev.name}}</h3>
                <ul class="card-Event__Tickets">
                    <li class="card-Event__Ticket" v-for="tick in ev.tickets" :key="tick.id">

                        <div v-if="tick.action !== 'closed'" class="card-event__TicketRow">
                            <div class="card-Event__TicketLogo d-none d-md-block">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                    <path class="eSvgHighlight"
                                          d="M23,10.61,10.62,23a1.76,1.76,0,0,1-2.46,0L6.45,21.24a2.63,2.63,0,0,0,0-3.7,2.52,2.52,0,0,0-1.85-.76,2.52,2.52,0,0,0-1.85.76L1,15.83a1.76,1.76,0,0,1,0-2.46L13.38,1a1.76,1.76,0,0,1,2.46,0l1.7,1.7a2.52,2.52,0,0,0-.76,1.85,2.52,2.52,0,0,0,.76,1.85,2.63,2.63,0,0,0,3.7,0L23,8.15a1.75,1.75,0,0,1,0,2.46ZM10.86,19.27l8.4-8.4a.85.85,0,0,0,0-1.22L14.34,4.72a.89.89,0,0,0-1.22,0l-8.4,8.4a.85.85,0,0,0,0,1.22l4.92,4.92a.89.89,0,0,0,1.22,0ZM13.73,6l4.3,4.3L10.25,18,6,13.73Z"></path>
                                </svg>
                            </div>
                            <div class="card-Event__TicketInfo d-flex flex-row">
                                <div class="d-flex flex-sm-row flex-column w-100 justify-content-between align-items-baseline">
                                    <div class="card-Event__TicketTitle d-flex flex-column text-left">
                                        <h5>{{tick.name}}</h5>
                                        <!--<span class="card-Event__TicketSubtitle">{{tick.description}}</span>-->
                                        <div v-html="tick.description"></div>
                                    </div>

                                    <div class="d-flex align-items-center justify-content-sm-center">
                                        <div class="card-Event__TicketPrice">
                                            <span v-if="tick.price !== ''">{{tick.price}} €</span><span v-if="tick.priceDescription !== ''">{{tick.priceDescription}}</span>
                                        </div>
                                        <div class="card-Event__TicketInfoToggle" v-b-toggle="'accordion-'+ tick.id">
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                                <path class="eSvgHighlight"
                                                      d="M12,1.2A10.8,10.8,0,1,0,22.8,12,10.8,10.8,0,0,0,12,1.2Zm2.14,16-1.24.47a3.28,3.28,0,0,1-1.07.16,2.14,2.14,0,0,1-1.46-.46,1.49,1.49,0,0,1-.52-1.17,4.16,4.16,0,0,1,0-.56A6.55,6.55,0,0,1,10,15l.65-2.29c.06-.22.11-.43.15-.62a2.75,2.75,0,0,0,.06-.54.83.83,0,0,0-.18-.61,1,1,0,0,0-.69-.17,1.82,1.82,0,0,0-.52.08L9,11l.17-.71q.64-.26,1.22-.44a3.65,3.65,0,0,1,1.1-.18,2.09,2.09,0,0,1,1.44.45,1.49,1.49,0,0,1,.51,1.17c0,.1,0,.27,0,.53a3.53,3.53,0,0,1-.13.69l-.65,2.28a6.38,6.38,0,0,0-.14.63,3.36,3.36,0,0,0-.06.53.76.76,0,0,0,.2.62,1.14,1.14,0,0,0,.71.17,2,2,0,0,0,.53-.08,3,3,0,0,0,.43-.15ZM14,7.93a1.62,1.62,0,0,1-2.18,0,1.33,1.33,0,0,1-.45-1,1.34,1.34,0,0,1,.45-1A1.61,1.61,0,0,1,14,5.9a1.35,1.35,0,0,1,.45,1A1.33,1.33,0,0,1,14,7.93Z"></path>
                                            </svg>
                                        </div>
                                        <div class="card-Event__TicketSubscribe">
                                            <div v-if="tick.action === 'login'">
                                                <button @click="openLogin" type="button"
                                                        class="btn btn-outline-primary">
                                                    {{tick.actionMessage}}
                                                </button>
                                                <!--<span @click="openLogin">{{tick.actionMessage}}</span> -->
                                            </div>

                                            <div v-else-if="tick.action === 'subscribe'">
                                                <button value="standard" @click="inviaForm(tick.id, ev.url)"
                                                        type="submit"
                                                        class="btn btn-outline-primary">{{tick.actionMessage}}
                                                </button>
                                            </div>

                                            <!--<a v-else-if="tick.action === 'subscribe'" type="submit"  value="standard" @click="inviaForm(tick.id, ev.url)">-->
                                            <!--{{tick.actionMessage}}-->
                                            <!--</a>-->
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div v-else class="card-event__TicketRow">
                            <div class="card-Event__TicketLogo d-none d-md-block">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                    <path class="eSvgHighlight"
                                          d="M23,10.61,10.62,23a1.76,1.76,0,0,1-2.46,0L6.45,21.24a2.63,2.63,0,0,0,0-3.7,2.52,2.52,0,0,0-1.85-.76,2.52,2.52,0,0,0-1.85.76L1,15.83a1.76,1.76,0,0,1,0-2.46L13.38,1a1.76,1.76,0,0,1,2.46,0l1.7,1.7a2.52,2.52,0,0,0-.76,1.85,2.52,2.52,0,0,0,.76,1.85,2.63,2.63,0,0,0,3.7,0L23,8.15a1.75,1.75,0,0,1,0,2.46ZM10.86,19.27l8.4-8.4a.85.85,0,0,0,0-1.22L14.34,4.72a.89.89,0,0,0-1.22,0l-8.4,8.4a.85.85,0,0,0,0,1.22l4.92,4.92a.89.89,0,0,0,1.22,0ZM13.73,6l4.3,4.3L10.25,18,6,13.73Z"></path>
                                </svg>
                            </div>
                            <div class="card-Event__TicketInfo d-flex flex-row">
                                <div class="d-flex flex-sm-row flex-column w-100 justify-content-between align-items-baseline">
                                    <div class="card-Event__TicketTitle d-flex flex-column text-left ">
                                        <h5>{{tick.name}}</h5>
                                        <!--<span class="card-Event__TicketSubtitle">{{tick.description}}</span>-->
                                        <!--<div v-html="tick.description"></div>-->
                                    </div>
                                    <div class="card-Event__TicketPrice">
                                    </div>
                                    <div class="d-flex align-items-center justify-content-center">
                                        <div class="card-Event__TicketInfoToggle">
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                                <path class="eSvgHighlight"
                                                      d="M12,1.2A10.8,10.8,0,1,0,22.8,12,10.8,10.8,0,0,0,12,1.2Zm2.14,16-1.24.47a3.28,3.28,0,0,1-1.07.16,2.14,2.14,0,0,1-1.46-.46,1.49,1.49,0,0,1-.52-1.17,4.16,4.16,0,0,1,0-.56A6.55,6.55,0,0,1,10,15l.65-2.29c.06-.22.11-.43.15-.62a2.75,2.75,0,0,0,.06-.54.83.83,0,0,0-.18-.61,1,1,0,0,0-.69-.17,1.82,1.82,0,0,0-.52.08L9,11l.17-.71q.64-.26,1.22-.44a3.65,3.65,0,0,1,1.1-.18,2.09,2.09,0,0,1,1.44.45,1.49,1.49,0,0,1,.51,1.17c0,.1,0,.27,0,.53a3.53,3.53,0,0,1-.13.69l-.65,2.28a6.38,6.38,0,0,0-.14.63,3.36,3.36,0,0,0-.06.53.76.76,0,0,0,.2.62,1.14,1.14,0,0,0,.71.17,2,2,0,0,0,.53-.08,3,3,0,0,0,.43-.15ZM14,7.93a1.62,1.62,0,0,1-2.18,0,1.33,1.33,0,0,1-.45-1,1.34,1.34,0,0,1,.45-1A1.61,1.61,0,0,1,14,5.9a1.35,1.35,0,0,1,.45,1A1.33,1.33,0,0,1,14,7.93Z"></path>
                                            </svg>
                                        </div>
                                        <div class="card-Event__TicketSubscribe">
                                            <div v-if="tick.action === 'closed'">
                                                <span>{{tick.actionMessage}}</span>
                                            </div>

                                            <!--<a v-else-if="tick.action === 'subscribe'" type="submit"  value="standard" @click="inviaForm(tick.id, ev.url)">-->
                                            <!--{{tick.actionMessage}}-->
                                            <!--</a>-->
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <b-collapse :id="'accordion-'+ tick.id" accordion="my-accordion" role="tabpanel">
                            <div class="card-Event__TicketPrices d-flex align-items-center">
                                <div class="card-Event__TicketPricesPoints d-none d-sm-block">
                                </div>
                                <ul class="card-Event__TicketPricesList w-100">
                                    <li class="card-Event__ticketPricesListItem" v-for="(price, index) in tick.prices"
                                        :key="index">
                                        <div class="d-flex align-items-center justify-content-between">
                                            <div class="card-Event__TicketPricesListInfo text-left">
                                                <span :class="{'card-Event__ticketPricesListItem-Active': (tick.currentPrice === index)} ">{{price.endDate}}<span
                                                        v-if="price.maxSubscriptions !== ''">, {{price.maxSubscriptions}}</span></span>
                                            </div>
                                            <div class="card-Event__TicketPricesListPrice">
                                                <span :class="{'card-Event__ticketPricesListItem-Active': (tick.currentPrice === index)} ">
                                                    <span v-if="price.price !== ''">{{price.price}} €</span><span v-if="price.priceDescription !== ''">{{price.priceDescription}}</span>
                                                </span>
                                            </div>
                                        </div>

                                    </li>
                                </ul>
                            </div>
                        </b-collapse>
                    </li>
                </ul>
            </div>
        </section>


        <!--<div v-for="ev in sub.events" :key="ev.id">-->
        <!--{{ev.name}}<br>-->
        <!--<div v-for="tick in ev.tickets" :key="tick.id">-->
        <!--{{tick.name}}<br>-->
        <!--<div v-html="tick.description"></div>-->
        <!--Action: {{tick.action}}<br>-->
        <!--<b-button>{{tick.actionMessage}}</b-button>-->
        <!--</div>-->
        <!--</div>-->
    </div>
</template>

<script>
    import BaseVue from '../views/BaseVue'
    import {EventBus} from '../util/event-bus'

    export default {
        name: 'Iscriviti',
        extends: BaseVue,
        props: ['data'],
        data() {
            return {
                sub: null,
                link: null,
                hiddenForm: {
                    id: null,
                    token: null,
                    action: null
                }
            }
        },
        computed: {},
        mounted() {
            EventBus.$on('login', () => {
                this.getInfoIscrizioni()
            })
            EventBus.$on('logout', () => {
                this.getInfoIscrizioni()
            })
            this.getInfoIscrizioni()
        }, methods: {
            async getInfoIscrizioni() {
                this.sub = await this.getEnow('/race/subscription/' + this.data.ID)
            }, openLogin() {
                EventBus.$emit('open_login')
            }, async inviaForm(id, url) {
                this.hiddenForm.action = this.$store.getters.eno + url// + '/' 19/12/22 tolto perchè sembra incasinare il browser
                this.hiddenForm.id = id
                this.hiddenForm.token = this.$store.getters.token
                await this.$nextTick()
                this.$refs.form_subscription.submit()
            }
        }
    }
</script>

<style scoped lang="scss">
    .content_block {
        max-width: 74rem;
        margin-right: auto;
        margin-left: auto;
    }

    .card-Event {
        margin-bottom: 2.5rem;
        box-shadow: 0px 3px 15px rgba(0, 0, 0, 0.2);
    }

    .card-Event__Title {
        background-color: #FC8300;
        border-radius: .5rem .5rem 0 0;
        overflow: hidden;
        font-weight: 600;
        font-size: 1.125rem;
        color: #fff;
        margin: 0;
        padding: 1rem 1.5rem;
        text-align: left;
        font-family: "Roboto Condensed", sans-serif;
    }

    .card-Event__Tickets {
        border-radius: 0 0 .5rem .5rem;
        overflow: hidden;
        display: block;
        list-style-type: none;
        margin: 0;
        padding: 0;

    }

    .card-Event__Tickets li {
        border-top: 2px solid #efefef;
    }

    .card-Event__Tickets li:first-child {
        border-top: none;
    }

    .card-Event__Ticket {

    }

    .card-event__TicketRow {
        display: block;
        margin-left: -.9375rem;
        margin-right: -.9375rem;

        border-bottom: 0;
        border-top: 0;
        min-height: 6.25rem;
        margin: 0;
        padding: 1rem 0;
        display: flex;
        background-color: white;
    }

    .card-Event__TicketLogo {
        /*position: relative;*/
        /*float: left;*/
        width: 8.33333%;
        min-height: 1px;
        padding-left: .9375rem;
        padding-right: .9375rem;
        padding-top: 1rem;
        padding-bottom: 1rem;
        /*text-align: center;*/
    }

    .card-Event__TicketLogo svg {
        fill: #ACBBC4;
        height: 2rem;
    }

    .card-Event__TicketInfo {
        /*position: relative;*/
        /*float: left;*/
        width: 91.66667%;
        min-height: 1px;
        padding-left: .9375rem;
        padding-right: .9375rem;
        border-left: 2px solid #efefef;
    }

    .card-Event__TicketTitle {
        position: relative;
        float: left;
        /*width: 58.33333%;*/
        min-height: 1px;
        padding-left: .9375rem;
        padding-right: .9375rem;
        padding-top: .5rem;
        padding-bottom: 1rem;
        display: flex;
        font-family: "Roboto Condensed", sans-serif;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        color: #555;
    }

    @media (min-width: 564px) {
        .card-Event__TicketTitle {
            width: 50%;
        }
    }


    .card-Event__TicketSubtitle {
        font-weight: 200;
        font-size: .875rem;
        color: #96a3aa;
    }

    .card-Event__TicketPrice {
        min-height: 1px;
        padding-left: .9375rem;
        padding-right: .9375rem;
        padding-top: 1rem;
        padding-bottom: 1rem;
        font-family: "Roboto Condensed", sans-serif;
        font-weight: 700;
        font-size: 2rem;
        text-align: right;
        line-height: 2.25rem;
        color: #555;
    }

    .card-Event__TicketPrices {
        /*display: block;*/
        /*margin-left: -.9375rem;*/
        /*margin-right: -.9375rem;*/
        background-color: #e3f5fe;
        /*border-bottom: 1px solid #99d4fc;*/
        /*border-top: 1px solid #99d4fc;*/
        /*margin: 0;*/
        /*position: relative;*/

    }

    .card-Event__TicketPricesArrowRow {
        /*display: block;*/
        /*margin-left: -.9375rem;*/
        /*margin-right: -.9375rem;*/
        /*margin: 0;*/
    }

    .card-Event__TicketPricesArrow {
        /*position: relative;*/
        /*float: left;*/
        /*width: 8.33333%;*/
        /*min-height: 1px;*/
        /*padding-left: .9375rem;*/
        /*padding-right: .9375rem;*/
        /*left: 75%;*/
    }

    .card-Event__TicketPricesArrow span {
        /*background-color: #e3f5fe;*/
        /*border-left: 1px solid #99d4fc;*/
        /*border-top: 1px solid #99d4fc;*/
        /*display: block;*/
        /*height: 1.5rem;*/
        /*left: 50%;*/
        /*position: absolute;*/
        /*top: 0;*/
        /*transform: translateY(-1.06066rem) rotate(45deg);*/
        /*transform-origin: top left;*/
        /*width: 1.5rem;*/
        /*z-index: 10;*/
    }

    .card-Event__TicketPricesPoints {
        /*position: relative;*/
        /*float: left;*/
        width: 8.33333%;
        min-height: 1px;
        padding-left: 2rem;
        padding-right: .9375rem;
    }

    .card-Event__TicketPricesList {
        /*position: relative;*/
        /*float: left;*/
        /*width: 91.66667%;*/
        /*min-height: 1px;*/
        /*padding-left: .9375rem;*/
        /*padding-right: .9375rem;*/
    }

    .card-Event__ticketPricesListItem-Active {
        font-weight: bold;
        color: #000;
        font-family: "Roboto Condensed", sans-serif;
    }

    .card-Event__ticketPricesListItem {
        font-size: 0.8rem;
        padding-top: 10px;
        padding-bottom: 10px;
        border-top: 1px solid #061BB0;
        padding-right: 0.5rem;
        padding-left: 0.5rem;
        /*color: #99d4fc;*/
        /*display: block;*/
        /*height: 4.5rem;*/
    }

    @media (min-width: 564px) {
        .card-Event__ticketPricesListItem {
            font-size: 1.3rem;
            padding-left: 2rem;
            padding-right: 2rem;
        }
    }

    .card-Event__ticketPricesListItem--Selected {
        color: #0090ff;
    }

    .card-Event__ticketPricesListItem:first-of-type {
        border-top: 0;
    }

    .card-Event__ticketPricesListItem div {
        /*line-height: 1.5rem;*/
        /*padding-top: 1.5rem;*/
        /*padding-bottom: 1.5rem;*/
    }

    .card-Event__TicketPricesListInfo {
        /*font-weight: 200;*/
        /*font-size: 1rem;*/
    }

    .card-Event__TicketPricesListPrice {
        /*font-weight: 500;*/
        /*font-size: 1.5rem;*/
        /*padding: 0 10px;*/
        /*text-align: right;*/
        /*float: right;*/
    }

    .card-Event__TicketInfoToggle {
        /*position: relative;*/
        /*float: left;*/
        /*width: 8.33333%;*/
        min-height: 1px;
        padding-left: 2rem;
        padding-right: 2rem;
        /*padding-top: 1rem;*/
        /*padding-bottom: 1rem;*/
        /*text-align: center;*/
        fill: #061BB0;
    }

    .card-Event__TicketInfoToggle svg {
        cursor: pointer;
        height: 2rem;
    }

    .card-Event__TicketSubscribe {
        /*position: relative;*/
        /*float: left;*/
        /*width: 16.66667%;*/
        min-height: 1px;
        padding-left: .9375rem;
        padding-right: .9375rem;
        /*padding-bottom: 1rem;*/
        /*padding-top: 1rem;*/
        /*text-align: center;*/
        cursor: pointer;
        font-family: "Roboto Condensed", sans-serif;
    }

    .card-Event__TicketSubscribe span {
        color: #ccc;
    }

    .card-Event__TicketSubscribe a {
        margin: 0;
        padding: 0;
        display: block;
        width: 100%;
        font-weight: 200;
        font-size: 1.125rem;
        background-color: #fff;
        border: 0;
        color: #96a3aa;
        text-transform: none;
    }


</style>
